<template>
  <div style="display: inline">
    <v-menu offset-y>
      <template v-if="column" v-slot:activator="{ on, attrs }">
        <template v-if="pickerOnly">
          <div
            class="picker-only"
            v-bind="attrs"
            v-on="on"
            :title="column.name" @click="mode = ''">
              <div class="picker-only-text">{{ column.name }}</div>
              <v-icon class="float-right"
                >mdi-menu-down</v-icon
              >
          </div>
        </template>
        <template v-else>
          <v-row
            dense
            class="columnPicker"
            v-bind="attrs"
            v-on="on"
            :title="column.name"
          >
            <v-col @click="mode = ''" :cols="9 - (allowRemove ? 1 : 0)">
              <div class="pickerContent">{{ column.name }}</div>
            </v-col>
            <v-col cols="1">
              <v-icon @click="mode = ''"
                class="columnAdder"
                title="Change column"
                >mdi-chevron-down</v-icon
              ></v-col
            >
            <v-col cols="1"> <!--v-if="allowStyling" -->
              <v-icon
                class="columnAdder"
                @click.stop="showColumnSettings"
                title="Custom settings"
                >mdi-cog</v-icon
              ></v-col
            >
            <v-col cols="1"
                v-if="allowRemove">
              <v-icon
                class="columnAdder"
                title="Remove column"
                @click.stop="$emit('removeColumn', columnType, index)"
                >mdi-minus-thick</v-icon
              ></v-col
            >
            <v-col cols="1"
                v-if="allowAdd">
              <v-icon class="columnAdder" @click="mode = 'add'" title="Add column"
                >mdi-plus-thick</v-icon
              ></v-col
            >
          </v-row>
        </template>
      </template>
      <template v-else v-slot:activator="{ on, attrs }">
        <v-row v-bind="attrs" v-on="on">
          <v-col cols="1">
            <v-icon class="columnAdder" @click="mode = 'add'" title="Add column"
              >mdi-plus-thick</v-icon
            ></v-col
          ></v-row
        >
      </template>
      <v-list dense style="max-height: 700px" v-if="column || mode === 'add'">
        <template v-if="!pickerOnly">
          <v-list-item>
            <v-list-item-group>{{
              mode === "add" ? "Pick column to add:" : "Change existing column:"
            }}</v-list-item-group> 
          </v-list-item>
          <v-divider></v-divider>
        </template>
        <v-list-item
          dense
          v-for="(co, coi) in columnsAvailable.filter((x) => !x.hidden)"
          :key="'co' + coi"
          :style="
            'background-color: ' + (column && co.name === column.name ? '#daecf2;' : 'white;')
          "
          @click="
            $emit(
              mode === 'add' ? 'addColumn' : 'changeColumn',
              columnType,
              co,
              index
            )
          "
        >
          <v-list-item-title>{{ co.name }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-dialog v-model="settings.show" max-width="900">
      <v-card v-if="column">
        <v-card-title class="text-h5"> {{ column.name }} Settings ({{column.data_type}})</v-card-title>
        <v-card-text><v-container>
          <v-row v-if="allowTitleOverride">
            <v-col cols="4"><h3>Column Heading Title:</h3></v-col>
            <v-col><v-text-field v-model="settings.overrideTitle" label="Title" dense hide-details outlined></v-text-field></v-col>
          </v-row>
          <v-row v-if="allowPrefix">
            <v-col cols="4"><h3>Value Prefix/Suffix:</h3></v-col>
            <v-col><v-text-field v-model="settings.prefix" label="Prefix" dense hide-details outlined></v-text-field></v-col>
            <v-col><v-text-field v-model="settings.suffix" label="Suffix" dense hide-details outlined></v-text-field></v-col>
          </v-row>
          <v-row v-if="allowShowTitle">
            <v-col cols="4"><h3>Show Detail Heading:</h3></v-col>
            <v-col><v-switch v-model="settings.detailHeadingVisible" dense hide-details outlined></v-switch></v-col>
          </v-row>
          <v-row v-if="allowDefaultSort">
            <v-col cols="4"><h3>Default Sort:</h3></v-col>
            <v-col cols="4">
              <v-select
                v-model="settings.defaultSort"
                dense hide-details outlined
                title="Rows load pre-sorted by this column; only one column or measure can hold the default sort"
                :items="[
                  { text: 'None', value: null },
                  { text: 'Ascending', value: 'asc' },
                  { text: 'Descending', value: 'desc' },
                ]"
                item-text="text" item-value="value"
              ></v-select>
            </v-col>
          </v-row>
          <v-row v-if="allowDisplayType">
            <v-col cols="4"><h3>Value Display Type</h3></v-col>
            <v-col><v-select v-model="settings.valueDisplayType" dense hide-details outlined :items="['text', 'chip']"></v-select></v-col>
              <v-col>
                <v-select
                            hide-details
                            outlined
                            dense clearable
                            label="Display Icon"
                            :items="
                              [
                                'mdi-view-sequential',
                                'mdi-view-comfy',
                                'mdi-file-tree-outline',
                                'mdi-receipt-text',
                                'mdi-radar',
                                'mdi-card-multiple-outline',
                                'people',
                                'transfer_within_a_station',
                                'elevator',
                                'account_balance',
                                'mdi-vector-combine',
                                'mdi-file-cabinet',
                                'mdi-alarm-panel',
                                'mdi-artboard',
                                'mdi-ballot',
                                'mdi-blur-linear',
                                'cube',
                              ]
                            "
                            v-model="settings.valueIcon"
                            ><template v-slot:item="{ item }"
                              ><v-icon>{{ item }}</v-icon> </template
                            ><template v-slot:selection="{ item }"
                              ><v-icon>{{ item }}</v-icon>
                            </template></v-select
                          >
                </v-col>
          </v-row>
          <v-row v-if="allowIncludeInColumn">
            <v-col cols="4"><h3>Embed in Column</h3></v-col>
            <v-col><v-select v-model="settings.containerColumn" dense hide-details outlined clearable :items="columnsUsed.filter(x => x.name !== column.name)" item-text="name" item-value="column"></v-select></v-col>
            <template v-if="settings.containerColumn">
              <v-col cols="3" v-if="allowIncludeRangeColumn">
              </v-col>
              <v-col cols="4"></v-col>
              <v-col cols="4" v-if="allowIncludeRangeColumn"><v-switch label="Embed as Range" v-model="settings.containerColumnShowRange"></v-switch></v-col>
              <v-col cols="4" v-if="allowIncludeRangeColumn && measuresAvailable"><v-select dense outlined hide-details v-if="!settings.containerColumnShowRange" label="Embed Groups with Measure:" clearable :items="measuresAvailable" item-value="id" item-text="title" v-model="settings.containerColumnGroupMeasure"></v-select></v-col>
            </template>
          </v-row>
          <v-row v-if="allowDisplayType && ['date','month','year'].some(x => x === column.data_type)">
            <v-col cols="4"><h3>Chart Display:</h3></v-col>
            <v-col><v-switch label="Show as Range" v-model="settings.chartDisplayRange"></v-switch></v-col>
              <v-col>
                <v-text-field v-model="settings.chartDisplayRangeQuantity" label="Last X Periods" type="number" dense hide-details outlined></v-text-field>
                </v-col>
          </v-row>
          <v-row v-if="allowShowDescriptor">
            <v-col cols="4"><h3>Node Description:</h3></v-col>
            <v-col>
              <v-switch label="Show description in next column" v-model="settings.showDescriptor" dense hide-details></v-switch>
              <v-switch v-if="settings.showDescriptor" label="Editable (if user has permission)" v-model="settings.descriptorEditable" dense hide-details class="ml-8"></v-switch>
            </v-col>
          </v-row>
          <v-row v-if="allowIncludeInColumn && index === 0">
            <v-col cols="4"><h3>Node Actions:</h3></v-col>
            <v-col><v-select label="Alignment" v-model="settings.nodeActionsAlignment" :items="['left','inline','right']"></v-select></v-col>
            <v-col><v-switch label="Selectable (for docs)" v-model="settings.nodeSelectable"></v-switch></v-col>
          </v-row>
          <template v-if="allowStyling">
          <v-row align="center">
            <v-col cols="4"><h3>Colours:</h3></v-col>
            <v-col cols="3">
              <v-menu offset-y :close-on-content-click="false">
                <template v-slot:activator="{ on, attrs }">
                  <div class="colour-swatch-button" v-bind="attrs" v-on="on" title="Background colour">
                    <span class="colour-swatch"><span class="colour-swatch-fill" :style="{ backgroundColor: settings.color_b }"></span></span>
                    Background
                  </div>
                </template>
                <v-color-picker
                  v-model="settings.color_b"
                  mode="hexa"
                  show-swatches
                ></v-color-picker>
              </v-menu>
            </v-col>
            <v-col cols="2">
              <v-menu offset-y :close-on-content-click="false">
                <template v-slot:activator="{ on, attrs }">
                  <div class="colour-swatch-button" v-bind="attrs" v-on="on" title="Font colour">
                    <span class="colour-swatch"><span class="colour-swatch-fill" :style="{ backgroundColor: settings.color_f }"></span></span>
                    Font
                  </div>
                </template>
                <v-color-picker
                  v-model="settings.color_f"
                  mode="hexa"
                  show-swatches hide-mode-switch
                ></v-color-picker>
              </v-menu>
            </v-col>
            <v-col cols="2">
              <div
                :style="{
                  color: settings.color_f,
                  backgroundColor: settings.color_b,
                }"
                style="padding: 2px 5px; border-radius: 5px; border: 1px solid lightgray; text-align: center;"
              >
                Sample Text
              </div>
            </v-col>
            <v-col cols="1"><v-btn small text @click="setDefaultColours">Reset</v-btn></v-col>
          </v-row>
          </template>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="settings.show = false"> Cancel </v-btn>
          <!-- <v-btn text @click="saveSettingsRevert" v-if="allowStyling"> Use Default </v-btn> -->
          <v-btn text @click="saveSettings"> Save </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "cHierarchyViewColumnPicker",
  props: {
    column: Object,
    index: Number,
    columnsAvailable: Array,
    columnsUsed: Array,
    columnType: String,
    columnSubject: String,
    allowRemove: Boolean,
    allowAdd: Boolean,
    allowStyling: Boolean,
    allowPrefix: Boolean,
    allowTitleOverride: Boolean,
    allowShowTitle: Boolean,
    allowDisplayType: Boolean,
    allowIncludeInColumn: Boolean,
    allowIncludeRangeColumn: Boolean,
    allowShowDescriptor: Boolean,
    pickerOnly: Boolean,
    defaultColours: Object,
    measuresAvailable: Array,
    allowDefaultSort: Boolean,
    defaultSort: String, // null | 'asc' | 'desc' — is this column the view's default sort?
  },
  data: function () {
    return {
      settings: { 
        show: false, 
        color_f: this.defaultColours?.font || "#878787", 
        color_b: this.defaultColours?.background || "#ffffff00", 
        prefix: "", 
        suffix: "", 
        title: "", 
        detailHeadingVisible: false, 
        valueDisplayType: "text",
        containerColumn: null,
        containerColumnShowRange: false,
        containerColumnGroupMeasure: null,
        valueIcon: null,
        chartDisplayRange: null,
        chartDisplayRangeQuantity: 0,
        nodeActionsAlignment: "right'",
        nodeSelectable: false,
        showDescriptor: false,
        descriptorEditable: false,
        defaultSort: null,
        // valueRangeColumns: [],
      },
      mode: "",
    };
  },
  components: {},
  watch: {},
  computed: {},
  created: function () {},
  methods: {
    showColumnSettings() {
      this.settings.prefix = this.column.prefix;
      this.settings.suffix = this.column.suffix;
      this.settings.overrideTitle = this.column.overrideTitle;
      this.settings.detailHeadingVisible = this.column.detailHeadingVisible;
      this.settings.valueDisplayType = this.column.valueDisplayType;
      this.settings.containerColumn = this.column.containerColumn;
      this.settings.containerColumnShowRange = this.column.containerColumnShowRange;
      this.settings.containerColumnGroupMeasure = this.column.containerColumnGroupMeasure;
      this.settings.valueIcon = this.column.valueIcon;
      // this.settings.valueRangeColumns = this.column.valueRangeColumns;
      if (this.column.displayStyle) {
        this.settings.color_f = this.column.displayStyle.color;
        this.settings.color_b = this.column.displayStyle.backgroundColor;
      } else {
        this.setDefaultColours();
      }
      this.settings.chartDisplayRange = this.column.chartDisplayRange;
      this.settings.chartDisplayRangeQuantity = this.column.chartDisplayRangeQuantity;
      this.settings.nodeActionsAlignment = this.column.nodeActionsAlignment;
      this.settings.nodeSelectable = this.column.nodeSelectable;
      this.settings.showDescriptor = this.column.showDescriptor || false;
      this.settings.descriptorEditable = this.column.descriptorEditable || false;
      this.settings.defaultSort = this.defaultSort || null;
      this.settings.show = true;
    },
    saveSettings() {
      this.settings.show = false;
      if (this.allowDefaultSort && (this.settings.defaultSort || null) !== (this.defaultSort || null)) {
        this.$emit("setDefaultSort", {
          columnType: this.columnType,
          index: this.index,
          column: this.column.cache_column || this.column.column,
          sort: this.settings.defaultSort || null,
        });
      }
      this.$emit("changeColumnStyle",
        this.columnType,
        {
          color: this.settings.color_f,
          backgroundColor: this.settings.color_b,
        },
        this.index,
        this.settings.prefix,
        this.settings.suffix,
        this.settings.overrideTitle,
        this.settings.detailHeadingVisible,
        this.settings.valueDisplayType,
        this.settings.containerColumn,
        this.settings.containerColumnShowRange,
        this.settings.containerColumnGroupMeasure,
        this.settings.valueIcon,
        this.settings.chartDisplayRange,
        this.settings.chartDisplayRangeQuantity,
        this.settings.nodeActionsAlignment,
        this.settings.nodeSelectable,
        this.settings.showDescriptor,
        this.settings.descriptorEditable,
        // this.settings.valueRangeColumns,
      );
    },
    saveSettingsRevert() {
      this.settings.show = false;
      this.$emit("changeColumnStyle",
        this.columnType, null,
        this.index
      );
    },
    setDefaultColours() {
      this.settings.color_f = this.defaultColours?.font || "#878787";
      this.settings.color_b = this.defaultColours?.background || "#ffffff";
    },
  },
};
</script>
  <style scoped lang="scss">
.columnAdder {
  background-color: #e0f2f1;
  width: 22px;
  display: inline-table;
  margin-left: 3px;
  padding-left: 0px;
  padding-right: 0px;

  border: solid 1px #bcd4d0;
  border-radius: 5px;
  height: 24px;
  font-size: 12px;
}
.columnPicker {
  background-color: #e0f2f1;
  /*   width: calc(100% - 52px);
   display: inline-table; 
  display: flex;
  width: 100%;*/
  border: solid 1px #bcd4d0;
  border-radius: 5px;
  /* height: 24px; */
  font-size: 12px;
  padding-left: 6px;
  padding-right: 6px;
  font-weight: bold;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.pickerContent {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: inline-flex;
  padding-top: 3px;
  width: 100%;
}
.picker-only {
  border: 1px solid lightgray;
  border-radius: 8px;
  background-color: white;
  padding-left: 16px;
  padding-top: 8px;
}
.colour-swatch-button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border: 1px solid #bcd4d0;
  border-radius: 5px;
  background-color: #fafafa;
  font-size: 13px;
  cursor: pointer;
  user-select: none;
}
.colour-swatch {
  display: inline-block;
  width: 18px;
  height: 18px;
  border: 1px solid #bbbbbb;
  border-radius: 3px;
  /* checkerboard so transparent colours are recognisable */
  background-image: linear-gradient(45deg, #ddd 25%, transparent 25%, transparent 75%, #ddd 75%),
    linear-gradient(45deg, #ddd 25%, transparent 25%, transparent 75%, #ddd 75%);
  background-size: 8px 8px;
  background-position: 0 0, 4px 4px;
  overflow: hidden;
}
.colour-swatch-fill {
  display: block;
  width: 100%;
  height: 100%;
}
.picker-only-text {
  font-family: 'DM Sans';
  font-weight: 400;
  font-size: 14px;
  color: #000000;
  letter-spacing: 0;
  padding: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: calc(100% - 30px);
  display: inline-block;
}
</style>